import type { Format } from '../schemas/format';

/**
 * Lincoln-Douglas under CHSSA rules (Article XI §3): 6-3-7-3-4-6-3, 4 minutes of prep per debater.
 * One debater a side; the Affirmative speaks first and last. Value debate: no plans. (NSDA uses the same times.)
 */
export const LD_CHSSA: Format = {
  id: 'ld-chssa',
  version: 1,
  name: 'Lincoln-Douglas (CHSSA)',
  event: 'ld',
  ruleset: 'CHSSA',
  sideLabels: ['Aff', 'Neg'],
  teamSize: 1,
  order: 'fixed',
  prepSec: 240,
  graceSec: 10,
  points: { min: 25, max: 30, step: 0.1 },
  extensionRoles: ['final'],
  extensionNote: "An argument counts at the end if its debater carried it into their last speech: the 2AR for Aff, the NR for Neg.",
  segments: [
    { id: 'AC', kind: 'speech', role: 'constructive', label: 'Affirmative Constructive', short: 'AC', durationSec: 360, by: 'first', speakers: [1] },
    { id: 'CX1', kind: 'questioning', role: 'questioning', label: 'Cross-examination (Neg asks)', short: 'CX', durationSec: 180, by: 'both', speakers: [1] },
    { id: 'NC', kind: 'speech', role: 'constructive', label: 'Negative Constructive', short: 'NC', durationSec: 420, by: 'second', speakers: [1] },
    { id: 'CX2', kind: 'questioning', role: 'questioning', label: 'Cross-examination (Aff asks)', short: 'CX', durationSec: 180, by: 'both', speakers: [1] },
    { id: '1AR', kind: 'speech', role: 'rebuttal', label: 'First Affirmative Rebuttal', short: '1AR', durationSec: 240, by: 'first', speakers: [1] },
    { id: 'NR', kind: 'speech', role: 'final', label: 'Negative Rebuttal', short: 'NR', durationSec: 360, by: 'second', speakers: [1] },
    { id: '2AR', kind: 'speech', role: 'final', label: 'Second Affirmative Rebuttal', short: '2AR', durationSec: 180, by: 'first', speakers: [1] },
  ],
  sheets: [
    { id: 'case-first', title: '{first} case', owner: 'first', segmentIds: ['AC', 'CX1', 'NC', 'CX2', '1AR', 'NR', '2AR'] },
    { id: 'case-second', title: '{second} case', owner: 'second', segmentIds: ['NC', 'CX2', '1AR', 'NR', '2AR'] },
  ],
};
